import React from 'react';
import { Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { GroceriesFaqItem } from 'src/components/enterprise/features/Groceries/components/GroceriesFaqs/GroceriesFaqItem';
import { GroceriesContent } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';

interface GroceriesFaqsProps {
  groceriesContent: GroceriesContent;
}

export function GroceriesFaqs({
  groceriesContent,
}: GroceriesFaqsProps): JSX.Element {
  const lastIndex = groceriesContent.faqs.items.length - 1;
  return (
    <PageSection variant="rounded">
      <Stack y="lg">
        <Heading variant="h1">{groceriesContent.faqs.title}</Heading>
      </Stack>
      <Stack y="sm">
        {groceriesContent.faqs.items.map((faq, index) => (
          <GroceriesFaqItem
            key={faq.question}
            faq={faq}
            showDivider={index !== lastIndex}
          />
        ))}
      </Stack>
    </PageSection>
  );
}
